import Sparkle from '../src/Sparkle';
export default Sparkle;
